<div class="qr-view">
  <header class="qr-view-header">
    <img class="qr-view__logo" src="/assets/fitur-2026/imgs/cicerone-logo.svg">
  </header>
  
  <main 
    class="qr-view-main"
    [class.qr-view-main--send-email]="isSendEmailView()"
  >
    <div class="qr-view__qr">
      <div 
        class="qr__container"
        [class.qr__container--hidden]="isSendEmailView()"
      >
        <div class="qr__header">
          <ci-icon class="qr__icon" name="mobile" scale="1.5x"></ci-icon>
          
          <p class="qr__text">
            {{ 'Escanea con tu móvil para comenzar' | translate }}
          </p>
        </div>
        
        <div class="qr__qr">
          <img 
            class="qr__img" 
            src="/assets/fitur-2026/imgs/qr.svg"
          >
        </div>
      </div>
    </div>
    
    <div class="qr-view__form-container">
      <form 
        class="qr-view__form"
        [class.qr-view__form--visible]="isSendEmailView()"
      >
        <div class="form__input-email">
          <p class="input-email__supporting-text ci-paragraph-p1-regular">
            {{ 'En caso de no poder escanear el QR, ingrese el mismo email con el que generó su ruta' | translate }}
          </p>
          <ci-text-field-filled
            #emailFieldRef
            class="input-email__field"
            type="email"
            label="Email"
            [laceholder]=" 'Introduce tu email' | translate "
            [lang]="currentLang()"
            name="email"  
            [value]="email()"
            (change)="onEmailInputChange($event)"
          ></ci-text-field-filled> 
        </div>
        
        <ci-button 
          class="form__submit-button"
          class-name="ci-btn-primary-s-filled" 
          type="submit" 
          [aria-label]="'Enviar email' | translate"
          (click)="onSubmit()"
        >
          {{ 'Comenzar' | translate }}
        </ci-button>
      </form>
    </div>
    
    <button
      class="qr-view__email-button"
      (click)="onSendEmailClick()"
    >
      {{ (isSendEmailView() ? 'Volver al QR' : 'Iniciar sesión con email') | translate }}
    </button>
  </main>
</div>
